import { render, staticRenderFns } from "./dinamicFilters.vue?vue&type=template&id=3bc82072&"
import script from "./dinamicFilters.vue?vue&type=script&lang=js&"
export * from "./dinamicFilters.vue?vue&type=script&lang=js&"
import style0 from "./dinamicFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports